// extracted by mini-css-extract-plugin
export default {"container":"VerificationError_container__Je54G","box":"VerificationError_box__8Xh+F"};